<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Call Direction to Include</mat-label>
    <input
      autocomplete="off"
      type="text"
      formControlName="value"
      id="callDirectionId"
      lcsStaticSelect
      [lcsSingleSelect]="callDirectionSelect"
      [lcsStaticSelectValue]="form.get('value')?.value"
      [required]="true"
      />
      <lcs-static-select #callDirectionSelect [displayWith]="callDirectionDisplayWith">
        @for (callDirection of callDirections; track callDirection) {
          <lcs-option [value]="callDirection">
            {{ callDirection }}
          </lcs-option>
        }
      </lcs-static-select>
    </mat-form-field>
  </ng-container>
